import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ErrorBoundary } from "react-error-boundary";
import { createBrowserRouter, createRoutesFromElements, RouterProvider } from "react-router";
import GlobalError from "@/components/layout/global-error.jsx";
import { TiltifyConfigProvider } from "@/context/TiltifyConfigProvider.jsx";
import { TwitchConfigProvider } from "@/context/TwitchConfigProvider.jsx";
import Routes from "./routes/routes.jsx";

const queryClient = new QueryClient();

const appRouter = createBrowserRouter(createRoutesFromElements(Routes()));

export function App() {
  return (
    <ErrorBoundary FallbackComponent={GlobalError}>
      <TiltifyConfigProvider>
        <TwitchConfigProvider>
          <QueryClientProvider client={queryClient}>
            <RouterProvider router={appRouter} />
          </QueryClientProvider>
        </TwitchConfigProvider>
      </TiltifyConfigProvider>
    </ErrorBoundary>
  );
}
